import React, { useEffect, useState } from "react";
import axios from "axios";

export default function CardPage() {
  const [cards, setCards] = useState([]);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [message, setMessage] = useState("");

  const fetchCards = async () => {
    try {
      const res = await axios.post("https://tp-api.alsendi.me/cards");
      setCards(res.data.cards);
    } catch (err) {
      console.error("Failed to fetch cards:", err);
    }
  };

  useEffect(() => {
    fetchCards();
  }, []);

  const handleSelectCard = (cardId) => {
    setSelectedCardId(cardId);
    setMessage("");
  };

  const handlePayNow = async () => {
    if (!selectedCardId) {
      setMessage("No card selected.");
      return;
    }
  
    try {
      const res = await axios.post(
        "https://tp-api.alsendi.me/pay-by-saved-card",
        { id: selectedCardId }
      );
      setMessage("Payment initiated successfully.");
      window.location.href ="https://tap-payment.alsendi.me/payment-status?tap_id="+res.data.newCharge.id;
      console.log("Payment response:", res.data);
    } catch (err) {
      console.error("Payment failed:", err);
      setMessage("Payment failed. Please try again.");
    }
  };
  return (
    <div className="App">
      <header className="App-header">
        <h1>Saved Cards</h1>
        <h4>Filtered by Your IP</h4>
      </header>

      <main className="App-main">
        <div className="card-container">
          {cards.length === 0 ? (
            <p>No cards found for your IP.</p>
          ) : (
            <>
              <table className="w-full text-left mt-4 border border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-2 border">Select</th>
                    <th className="p-2 border">First 6</th>
                    <th className="p-2 border">Last 4</th>
                    <th className="p-2 border">Brand</th>
                  </tr>
                </thead>
                <tbody>
                  {cards.map((card) => (
                    <tr key={card.card_id}>
                      <td className="p-2 border">
                        <input
                          type="radio"
                          name="selectedCard"
                          checked={selectedCardId === card.card_id}
                          onChange={() => handleSelectCard(card.card_id)}
                        />
                      </td>
                      <td className="p-2 border">{card.first6}</td>
                      <td className="p-2 border">{card.last4}</td>
                      <td className="p-2 border">{card.brand}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="mt-4">
                <button
                  className="pay-button"
                  onClick={handlePayNow}
                  disabled={!selectedCardId}
                >
                  Pay Now
                </button>
              </div>
            </>
          )}
          {message && (
            <div className="mt-4 text-lg font-medium">
              {message}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}